<kiene-kiene-table [tableDescriptor]="tableDescriptor">
    <div toolbarElementCenter>
        <ng-container *ngIf="typCtrl?.value === 1 || typCtrl?.value === 0">
            <button mat-stroked-button color="accent" (click)="alleBestandsbuecherAbschliessen()">
                Alle Bestandsbücher protokollieren u. abschließen
            </button>
        </ng-container>
        <ng-container
            *ngIf="
                (typCtrl?.value === 2 || typCtrl?.value === 0) &&
                localStorageService.isCurrentUserVeterinarian() &&
                offeneImpfkontrollbuecher > 0
            "
        >
            <button
                mat-stroked-button
                color="accent"
                (click)="alleImpfkontrollbuecherAbschliessen()"
                style="margin-left: 12px"
            >
                Alle Impfkontrollbücher abschließen
            </button>
        </ng-container>
    </div>
    <div toolbarElementTop>
        <mat-radio-group [formControl]="typCtrl" class="radio-group">
            <mat-radio-button [value]="0">Alle</mat-radio-button>
            <mat-radio-button [value]="1">Bestandsb&uuml;cher</mat-radio-button>
            <mat-radio-button [value]="2">Impfkontrollb&uuml;cher</mat-radio-button>
        </mat-radio-group>
    </div>
</kiene-kiene-table>
